import React, { useState, useCallback } from 'react';

import Button, { BUTTON_TYPES } from 'buyside/components/presentation/Button/button';
import Modal from 'buyside/components/presentation/Modal/modal';

import { profileUrl } from 'buyside/util/urlHelper';

const IncompleteProfileModal = ({ noResearchRequired, profileId, ...props }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const renderOpenModalButton = useCallback(
    () => <Button {...props} id="apply-button" onClick={() => setIsModalOpen(true)} />,
    [props]
  );

  return (
    <Modal
      isOpen={isModalOpen}
      onClose={() => setIsModalOpen(false)}
      renderOpenModalButton={renderOpenModalButton}
      title="Complete Your Profile to Continue"
    >
      <p>
        In order to apply to a job posting through SumZero you must have filled out certain fields
        on your profile.
      </p>
      <p>Specifically, make sure the following are complete on your profile:</p>
      <ul>
        <li>Work Experience (including all dates of employment)</li>
        <li>Education</li>
        <li>Resume</li>
        <li>Answer all 5 questions in the Q&amp;A Section</li>
        {noResearchRequired ? (
          <li>Add a Research Document</li>
        ) : (
          <li>Posted a recent idea (within 3 months)</li>
        )}
      </ul>
      <Button
        text="Complete Your Profile"
        type={BUTTON_TYPES.PRIMARY}
        url={profileUrl(profileId)}
      />
    </Modal>
  );
};

export default IncompleteProfileModal;
